if ('function' === typeof importScripts) {
  importScripts(
    'https://www.gstatic.com/firebasejs/9.7.0/firebase-app-compat.js',
  )
  importScripts(
    'https://www.gstatic.com/firebasejs/9.7.0/firebase-messaging-compat.js',
  )

  const firebaseConfig = {
    apiKey: 'AIzaSyARZRxQh_wqy78o7DA9ZGNr2p-Dhrl2njQ',
    authDomain: 'clockin-app-development.firebaseapp.com',
    projectId: 'clockin-app-development',
    storageBucket: 'clockin-app-development.appspot.com',
    messagingSenderId: '861196756640',
    appId: '1:861196756640:web:1a474734255523e1a84bc5',
  }

  firebase.initializeApp(firebaseConfig)
  firebase.messaging()
}
